import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import translationsDE from '../../assets/translations/de.json';
import translationsEN from '../../assets/translations/en.json';
import { Locale } from '../../i18n';

dayjs.extend(utc);

const translationsMap = {
  [Locale.en]: translationsEN,
  [Locale.de]: translationsDE,
};

/**
 * Parses a date string and returns a formatted date string without the time component,
 * according to the specified language's locale format.
 *

 * @param date - The date string to parse. If not provided, the current date is used. e.g. 2025-06-25T09:56:23.811Z
 * @param language - The locale to use for formatting the date. Defaults to `Locale.en`. e.g. 'en'
 * @returns The formatted date string without the time component. e.g. 25.06.2025
 */
export const parseDateWithoutTime = (date?: string, language: Locale = Locale.en): string => {
  return dayjs.utc(date).format(translationsMap[language].translation.global.dateFormat);
};

/**
 * Parses a date string and returns a formatted date string with the time component in local time zone (input string should be in UTC),
 * according to the specified language's locale format.
 *

 * @param date - The date string to parse. If not provided, the current date is used. e.g. 2025-06-25T09:56:23.811Z
 * @param language - The locale to use for formatting the date. Defaults to `Locale.en`. e.g. 'en'
 * @returns The formatted date string with the time component. e.g. 25.06.2025 00:00
 */
export const parseDateWithTime = (date?: string, language: Locale = Locale.en): string => {
  return dayjs(date).format(translationsMap[language].translation.global.dateTimeFormat);
};
